import {Component, forwardRef, HostBinding, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';


@Component({
  selector: 'app-input-switch',
  encapsulation: ViewEncapsulation.None,
  imports: [
    ReactiveFormsModule,
    FormsModule
],
  templateUrl: './input-switch.component.html',
  styleUrl: './input-switch.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputSwitchComponent),
      multi: true
    }
  ]
})
export class InputSwitchComponent implements ControlValueAccessor, OnInit {
  @Input() id!: string;
  @HostBinding('attr.id') hostId: string | null = null;
  @Input() disabled = false;
  @Input() onLabel = '';
  @Input() offLabel = '';

  static nextId = 1;

  checked = false;

  onChange = (_: any) => {
  };

  onBlur = (_: any) => {
  }

  onChanged(event: any): void {
    this.checked = event && event.target && event.target.checked;
    this.onChange(this.checked);
  }

  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onBlur = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(obj: any): void {
    this.checked = obj;
  }

  ngOnInit(): void {
    if (!this.id) {
      this.id = 'input-switch-' + InputSwitchComponent.nextId;
      InputSwitchComponent.nextId++;
    }
  }

  hasLabel(): boolean {
    return !!this.onLabel || !!this.offLabel;
  }

  getLabel(): string {
    return (this.checked ? this.onLabel : this.offLabel) ?? '';
  }
}
